'use client';

import { updateCartQuantity } from '@/lib/redux/features/cart';
import { useAppDispatch } from '@/lib/redux/hooks';
import { useState } from 'react';
import { toast } from 'react-toastify';

type Product = {
  id: string;
  product_id: number;
  slug: string;
  product_name: string;
  product_thumbnail_image: string;
  is_preorder: 0 | 1;
  price: number;
  currency_symbol: string;
  quantity: number;
  lower_limit: number;
  upper_limit: number | null;
};

interface CartQuantityProps {
  product: Product;
  size?: string;
  className?: string;
}

const CartQuantity: React.FC<CartQuantityProps> = ({
  product,
  size = '',
  className,
}) => {
  const { id, quantity } = product;

  const dispatch = useAppDispatch();

  const handleDecrease = () => {
    if (quantity > 1) {
      const newQty = quantity - 1;
      dispatch(updateCartQuantity({ id: id, quantity: newQty }));
    }
  };

  const handleIncrease = () => {
    if (product.upper_limit && quantity >= product.upper_limit) {
      toast.error(`Maximum quantity of ${product.upper_limit} reached`, {
        position: 'top-left',
      });
      return;
    }
    const newQty = quantity + 1;
    dispatch(updateCartQuantity({ id: id, quantity: newQty }));
  };

  return (
    <div className={`quantity-button ${className}`}>
      <button
        className={`quantity-button__control quantity-button__control--decrease ${size}`}
        onClick={handleDecrease}
      >
        -
      </button>
      <span className={`quantity-button__display ${size}`}>{quantity}</span>
      <button
        className={`quantity-button__control quantity-button__control--increase ${size}`}
        onClick={handleIncrease}
      >
        +
      </button>
    </div>
  );
};

export default CartQuantity;
